import {
  type UpdateUserInfoRequest,
  type UpdateUserInfoResponse,
  authApi,
} from "@b2bportal/auth-api";
import { trackEvent } from "@hopper-b2b/api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import axios from "axios";

export const updateUserInfo = async (
  updateUserInfoRequest: UpdateUserInfoRequest,
  apiConfig?: IApiConfig
): Promise<UpdateUserInfoResponse> => {
  try {
    const response = await authApi(axios).apiV0AuthUserInfoUpdatePut(
      updateUserInfoRequest
    );
    return response.data;
  } catch (error) {
    trackEvent(
      {
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      },
      apiConfig
    );
    throw error;
  }
};
